import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.title',
    defaultMessage: 'Task Page',
  },
  taskId: {
    id: 'containers.OrderPage.components.TaskPage.taskId',
    defaultMessage: 'Task ID',
  },
  price: {
    id: 'containers.OrderPage.components.TaskPage.price',
    defaultMessage: 'Price',
  },
  cost: {
    id: 'containers.OrderPage.components.TaskPage.cost',
    defaultMessage: 'Cost',
  },
  discount: {
    id: 'containers.OrderPage.components.TaskPage.discount',
    defaultMessage: 'Discount',
  },
  priceNet: {
    id: 'containers.OrderPage.components.TaskPage.priceNet',
    defaultMessage: 'Net Price',
  },
  grossProfit: {
    id: 'containers.OrderPage.components.TaskPage.grossProfit',
    defaultMessage: 'Gross Profit',
  },
  deadline: {
    id: 'containers.OrderPage.components.TaskPage.deadline',
    defaultMessage: 'Deadline',
  },
  endCustomer: {
    id: 'containers.OrderPage.components.TaskPage.endCustomer',
    defaultMessage: 'End Client',
  },
  po: {
    id: 'containers.OrderPage.components.TaskPage.po',
    defaultMessage: 'P.O. / Purchase Order',
  },
  mediaPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.mediaPlaceholder',
    defaultMessage: 'Media',
  },
  territoryMarketPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.territoryMarketPlaceholder',
    defaultMessage: 'Territory/Market',
  },
  usagePlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.usagePlaceholder',
    defaultMessage: 'Airing time',
  },
  fileSpecLabel: {
    id: 'containers.OrderPage.components.TaskPage.fileSpecLabel',
    defaultMessage: 'Product info',
  },
  fileSpecPlaceholder: {
    id: 'containers.OrderPage.components.TaskPage.fileSpecPlaceholder',
    defaultMessage: 'Product info',
  },
  usageRights: {
    id: 'containers.OrderPage.components.TaskPage.usageRights',
    defaultMessage: 'Usage Rights',
  },
  wordCount: {
    id: 'containers.OrderPage.components.TaskPage.wordCount',
    defaultMessage: 'Word count',
  },
  onHold: {
    id: 'containers.OrderPage.components.TaskPage.onHold',
    defaultMessage: 'Task is on hold',
  },
  supplierUserIdCopiedSuccess: {
    id: 'containers.OrderPage.components.TaskPage.supplierUserIdCopiedSuccess',
    defaultMessage: 'Supplier UserId copied',
  },
  taskDeadlineAfterOrder: {
    id: 'containers.OrderPage.components.TaskPage.taskDeadlineAfterOrder',
    defaultMessage: 'The task deadline is after the order deadline.',
  },
  taskDeadlineAfterPr: {
    id: 'containers.OrderPage.components.TaskPage.taskDeadlineAfterPr',
    defaultMessage: 'The task deadline is after the post production deadline.',
  },
  taskDeadlineAfterOrderAndPr: {
    id: 'containers.OrderPage.components.TaskPage.taskDeadlineAfterOrderAndPr',
    defaultMessage: 'The task deadline is after the order and post production deadlines.',
  },
})
